export function getDeliverablesStatus(deliverables) {

  const deliverablesStatus = {};

  let setDeliverables = 0;
  let addedDeliverables = 0;
  let approvedDeliverables = 0;
  let liveDeliverables = 0;

  if (deliverables) {
    deliverables.forEach(deliverable => {
      setDeliverables++;
      const deliverableDocuments = deliverable.get('documents');
      if (deliverableDocuments && deliverableDocuments.first()) {
        addedDeliverables++;
        if (deliverableDocuments.find(document => document.get('approved') === true)) {
          approvedDeliverables++;
        }
      } else {
        if (deliverable.get('document')) addedDeliverables++;
        if (deliverable.getIn(['document', 'approved'])) approvedDeliverables++;
      }

      if (deliverable.get('live')) liveDeliverables++;
    });
  }

  deliverablesStatus.set = setDeliverables;
  deliverablesStatus.added = addedDeliverables;
  deliverablesStatus.approved = approvedDeliverables;
  deliverablesStatus.live = liveDeliverables;
  // TODO Changed approvedDeliverables back to liveDeliverables when we use live
  deliverablesStatus.setStatus = deliverableStatus(approvedDeliverables, setDeliverables);
  deliverablesStatus.addedStatus = deliverableStatus(addedDeliverables, setDeliverables);
  deliverablesStatus.approvedStatus = deliverableStatus(approvedDeliverables, addedDeliverables, setDeliverables);
  deliverablesStatus.liveStatus = deliverableStatus(liveDeliverables, approvedDeliverables);
  return deliverablesStatus;
}

function deliverableStatus(first, second, third) {
  let status = 'incomplete';
  if (first < second && (first || second)) status = 'pending';
  if (first === second && (first || second)) status = 'complete';
  if (third) {
    if (first === second && first !== third && (first || second)) status = 'pending';
  }
  return status;
}



/** WEBPACK FOOTER **
 ** ./src/utils/deliverable-status-functions.js
 **/